<template>
  <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Название</th>
          <th>Фактическое значение</th>
          <th>Среднее значение</th>
          <th>Минимальное значение</th>
          <th>Максимальное значение</th>
          <th>Период</th>
          <th>Высота</th>
          <th>Единица измерения</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in value" :key="item.name">
          <td>{{ item.name }}</td>
          <td>{{ item.val }}</td>
          <td>{{ item.avg }}</td>
          <td>{{ item.min }}</td>
          <td>{{ item.max }}</td>
          <td>{{ item.period }}</td>
          <td>{{ item.height }}</td>
          <td>{{ item.units }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "SynopMeasurementTable",
  props: {
    value: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {};
  }
};
</script>